import { render, staticRenderFns } from "./introHeader.vue?vue&type=template&id=84f70014&scoped=true&"
import script from "./introHeader.vue?vue&type=script&lang=js&"
export * from "./introHeader.vue?vue&type=script&lang=js&"
import style0 from "./introHeader.vue?vue&type=style&index=0&id=84f70014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f70014",
  null
  
)

export default component.exports